import { render, staticRenderFns } from "./codigo-politicas-gestion.vue?vue&type=template&id=e7130d24&lang=html&"
import script from "./codigo-politicas-gestion.vue?vue&type=script&lang=js&"
export * from "./codigo-politicas-gestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports